<template>
  <div style="margin-top:32px; background-color:#f2f2f2;min-height: 120vh;position: relative;" v-loading.fullscreen.lock="isLoading" element-loading-text="載入中...">
    <div class="sticky-top-section">
      <div class="hotel-toolbar">
        <div class="hotel-toolbar__row">
          <div class="hotel-toolbar__left">
            <div class="hotel-toolbar__mode-title">{{ mode === 'view' ? '檢視' : '預約' }}模式</div>
            <el-switch
              v-if="mode === 'booking'"
              class="hotel-toolbar__switch"
              :value="adminBackfillMode"
              active-text="補登歷史訂單"
              inactive-text=""
              @change="onAdminBackfillChange"
            />
          </div>
          <div class="hotel-toolbar__actions">
            <el-button
              v-if="mode === 'view'"
              size="extra-large"
              class="hotel-toolbar__btn hotel-toolbar__btn--primary"
              @click="mode === 'view' ? (mode = 'booking') : (mode = 'view')"
            >
              建立住宿訂單
            </el-button>
            <el-button
              v-if="mode === 'booking'"
              size="extra-large"
              class="hotel-toolbar__btn hotel-toolbar__btn--cancel"
              @click="mode === 'view' ? (mode = 'booking') : (mode = 'view')"
            >
              {{ mode === 'view' ? '建立住宿訂單' : '取消建立住宿訂單' }}
            </el-button>
            <el-button
              v-if="mode === 'booking' && currentSelectedRooms.length > 0"
              size="extra-large"
              class="hotel-toolbar__btn hotel-toolbar__btn--outline"
              @click="$refs.bookingMode.emptySelectedRooms()"
            >
              重選住宿房型
            </el-button>
          </div>
        </div>
        <el-alert
          v-if="mode === 'booking' && adminBackfillMode"
          class="hotel-toolbar__backfill-alert"
          type="warning"
          show-icon
          :closable="false"
          title="若該日期未設定價格或未開放，會自動帶入 0 元，請在訂單建立時以「加減價」功能自行補足應收金額，以免誤以 0 元結單。"
        />
      </div>

      <div class="statusCalendar">
        <el-row>
          <el-col :span="7" style="background-color: #ffffff;height: auto; font-weight: 400; color: #000000;">
            <el-row>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#EF6E70" />
                <div>待確認</div>
              </el-col>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#F7BCBD;" />
                <div>未報到</div>
              </el-col>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#81E2C5;" />
                <div>已報到</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#F7D9BB;" />
                <div>待報到</div>
              </el-col>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#D4D9DB;" />
                <div>未付款</div>
              </el-col>
              <el-col :span="8" class="status">
                <div style="width:16px;height:16px;background-color:#129BC4;" />
                <div>已退房</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="17" style="height: auto;">
            <Calendar :is-loading="isLoading" @week-change="handleWeekChange" />
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="scrollable-content">
      <div v-if="!currentProduct.id" style="width: 100%; text-align: center; margin-top: 100px;font-size:1.3rem">
        <div>目前沒有選擇服務地點，請至左上角選取<i class="el-icon-top-left" style="font-weight:900"/></div>
      </div>

      <div v-if="roomTypeList.length === 0 && currentProduct.id" style="width: 100%; text-align: center; margin-top: 100px;font-size:1.3rem">
        <div>該服務地點，目前尚未建立任何房型，請先至寵物住宿分頁設定</div>
        <el-button round style="margin-top:20px;" @click="$router.push('/hotel?tab1=1')">前往寵物住宿設定房型</el-button>
      </div>

      <ViewMode v-if="mode === 'view'" :roomTypeList="roomTypeList" :currentProduct="currentProduct" v-loading.fullscreen.lock="isLoading" element-loading-text="載入中..." />

      <BookingMode
        v-if="mode === 'booking'"
        ref="bookingMode"
        :roomTypeList="roomTypeList"
        @rooms-selected="handleRoomSelection"
        @leave-booking-mode="cancelledBookingMode"
        @reload-order-list="fetchRoomList"
        v-loading.fullscreen.lock="isLoading"
        element-loading-text="載入中..."
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import BookingMode from './components/hotelBookingMode.vue'
import Calendar from './components/hotelCalendar.vue'
import ViewMode from './components/hotelViewMode.vue'

import api from '@/src/router/views/schedule/hotel/api'
import { getHotelInfo } from '@/src/router/views/hotel/api'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'hotelIndex',
  components: {
    BookingMode,
    Calendar,
    FontAwesomeIcon,
    ViewMode,
  },
  props: {
    currentProduct: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mode: 'view', // 預設模式為檢視模式
      isLoading: false,
      roomTypeList: [],
      currentSelectedRooms: [],
      currentWeekStart: '',
      currentWeekEnd: '',
    }
  },
  computed: {
    ...mapState('hotel/order', ['adminBackfillMode']),
  },
  watch: {
    currentProduct() {
      this.fetchRoomList()
    },
    mode() {
      if (this.currentWeekStart && this.currentWeekEnd && this.currentProduct.id) {
        this.fetchRoomList()
      }
    },
  },
  created() {
    console.log('hotelIndex 元件已建立')
    this.fetchHotelSetting()
    this.fetchRoomList()
  },
  methods: {
    ...mapMutations('hotel/order', ['SET_ADMIN_BACKFILL_MODE']),
    ...mapMutations('hotel/setting', ['SET_SHOW_CHECKOUT_DATE']),
    async fetchHotelSetting() {
      try {
        const hotelInfo = await getHotelInfo()
        this.SET_SHOW_CHECKOUT_DATE(hotelInfo?.showCheckoutDate)
      } catch (error) {
        console.error('取得住宿設定失敗:', error)
        this.SET_SHOW_CHECKOUT_DATE(1)
      }
    },
    onAdminBackfillChange(val) {
      this.SET_ADMIN_BACKFILL_MODE(val)
      this.fetchRoomList()
    },
    checkIn() {
      alert('您的毛孩已成功入住！')
    },
    handleRoomSelection(selectedRooms) {
      console.log('選擇的房間 index 層:', selectedRooms)
      this.currentSelectedRooms = selectedRooms
    },
    cancelledBookingMode() {
      this.mode = 'view'
      this.currentSelectedRooms = []
      this.SET_ADMIN_BACKFILL_MODE(false)
      this.$refs.bookingMode.emptySelectedRooms()
    },
    async fetchRoomList() {
      if (!this.currentWeekStart || !this.currentWeekEnd || !this.currentProduct.id) {
        return
      }
      this.isLoading = true
      try {
        const productId = this.currentProduct.id
        const payload = { startDate: this.currentWeekStart, endDate: this.currentWeekEnd }
        if (this.mode === 'booking' && this.adminBackfillMode) {
          payload.adminBackfill = true
        }

        const res = await api.room.getHotelBookings(productId, payload)
        console.log(res)

        this.roomTypeList = res?.map((item) => ({
          ...item,
          isViewMore: true,
        }))
        this.$message.success('已更新房型列表')
      } catch (error) {
        console.error('房間列表獲取失敗:', error)
        this.$message.error('抓取房間列表失敗，請再嘗試一次')
      } finally {
        this.isLoading = false
      }
    },
    handleWeekChange(range) {
      this.currentWeekStart = range.start
      this.currentWeekEnd = range.end

      this.fetchRoomList()
    },
  },
}
</script>

<style scoped lang="scss">
.hotel-toolbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 8px 12px;
}

.hotel-toolbar__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  width: 100%;
}

.hotel-toolbar__left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 14px;
  min-width: 0;
  flex: 1 1 240px;
}

.hotel-toolbar__mode-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #000000;
  flex-shrink: 0;
}

.hotel-toolbar__switch {
  flex-shrink: 0;
}

.hotel-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 1 auto;
  max-width: 100%;
}

.hotel-toolbar__btn {
  height: 48px !important;
  padding-left: 18px !important;
  padding-right: 18px !important;
  border-radius: 8px !important;
  width: auto !important;
  min-width: 0 !important;
}

.hotel-toolbar__btn--primary {
  background-color: #ea6a2a !important;
  border-color: #ea6a2a !important;
  color: #ffffff !important;
}

.hotel-toolbar__btn--cancel {
  background-color: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
}

.hotel-toolbar__btn--outline {
  border: 1px solid #ea6a2a !important;
  color: #ea6a2a !important;
  background-color: #ffffff !important;
}

.hotel-toolbar__backfill-alert {
  width: 100%;
  margin: 0 !important;
  border-radius: 4px;
}

.sticky-top-section {
  position: sticky;
  top: 115px;
  z-index: 5;
  background-color: #f2f2f2;
  padding-bottom: 16px;
}

.el-button--text {
  font-weight: 400;
  color: #ea6a2a;
}

.el-col {
  text-align: center;

  .roomType .room & {
    line-height: 65px;
  }
  .statusCalendar & {
    height: 57px;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .status {
      flex-direction: row;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}

.statusCalendar {
  background-color: #ffffff;
  margin: 0 12px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* 可選：加一點陰影讓它跟下方內容有區隔 */
}
</style>
